/**
 * Randevu ödeme durumu etiketleri (AP).
 */
export function resolveOdemeDurumuGosterim(appointment) {
  if (!appointment) return null;

  if (appointment.odemeDurumuGosterim) {
    return {
      ...appointment.odemeDurumuGosterim,
      icon: appointment.odemeDurumuGosterim.tone === 'success'
        ? 'fa-check-circle'
        : 'fa-exclamation-circle',
    };
  }

  const v = String(appointment.odemeDurumu || '').toLowerCase();
  const beyanTahsil = appointment.odemeBeyanTahsilati === true;
  const kaynakNo = appointment.odemeBeyanKaynakRandevuNumarasi || null;
  const tahsilNo = appointment.odemeBeyanTahsilRandevuNumarasi || null;

  if (beyanTahsil) {
    return {
      label: 'Ödeme alındı',
      subLabel: kaynakNo
        ? `Bu ödeme beyanlı olarak ${kaynakNo} numaralı randevudaki borç için alındı`
        : null,
      tone: 'success',
      icon: 'fa-check-circle',
    };
  }

  if (v === 'alindi') {
    return {
      label: 'Ödeme alındı',
      subLabel: tahsilNo
        ? `${tahsilNo} numaralı randevuda beyan yoluyla tahsil edildi`
        : null,
      tone: 'success',
      icon: 'fa-check-circle',
    };
  }

  if (v === 'alinamadi' || appointment.odemeProblemli === true) {
    return {
      label: 'Ödeme alınamadı',
      subLabel: null,
      tone: 'danger',
      icon: 'fa-exclamation-circle',
    };
  }

  return null;
}
